var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.8 344.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daa79d;}.cls-2{fill:#f6bdac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.39,83.58a65.92,65.92,0,0,0-65.76-62.94,65.08,65.08,0,0,0-25.29,5A86.44,86.44,0,0,0,46.42,86.46c0,.35,0,.71,0,1.06A69.57,69.57,0,0,0,69.56,222.7H285.24a69.56,69.56,0,0,0,.15-139.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.76,249.12,170.23,275.9a8.23,8.23,0,0,1-13.78-9L174,240.1a8.23,8.23,0,1,1,13.77,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.05,275l-17.54,26.78a8.23,8.23,0,1,1-13.77-9l17.53-26.79a8.24,8.24,0,0,1,11.4-2.38h0A8.24,8.24,0,0,1,125.05,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.65,249.12,66.11,275.9a8.23,8.23,0,0,1-11.4,2.38h0a8.23,8.23,0,0,1-2.37-11.39L69.87,240.1a8.23,8.23,0,0,1,13.78,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.24,324.82l-8.72,13.33a8.23,8.23,0,1,1-13.78-9l8.73-13.33a8.23,8.23,0,0,1,11.39-2.38h0A8.23,8.23,0,0,1,62.24,324.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.54,275,220,301.74a8.23,8.23,0,1,1-13.77-9l17.53-26.79a8.24,8.24,0,0,1,11.4-2.38h0A8.24,8.24,0,0,1,237.54,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.43,311.05,154.9,337.84a8.23,8.23,0,0,1-13.78-9L158.66,302a8.23,8.23,0,1,1,13.77,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.29,321.72l-12.78,19.53a8.23,8.23,0,1,1-13.78-9l12.79-19.53a8.23,8.23,0,0,1,11.4-2.38h0A8.23,8.23,0,0,1,266.29,321.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.88,249.12,274.35,275.9a8.23,8.23,0,0,1-13.78-9l17.54-26.79a8.23,8.23,0,1,1,13.77,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.24,208.65H69.56A55.51,55.51,0,0,1,55.49,99.44L61.17,98l-.45-5.85c-.17-2.1-.24-3.95-.24-5.64A72.38,72.38,0,0,1,187.39,38.83L191,43l4.89-2.53a51.16,51.16,0,0,1,23.72-5.76A51.84,51.84,0,0,1,271.4,86.46c0,1.09,0,2.25-.15,3.66l-.53,7.51h14.52a55.51,55.51,0,0,1,0,111Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.5924e853ce15131e7e65374136a3f95f.svg";
export { ForwardRef as ReactComponent };